export default __webpack_public_path__ + "static/media/vanguard.e206b9f9.png";